import { makeStyles } from '@material-ui/core';
import sauterSymbol from '../../assets/sauter-symbol.png';

const useStyles = makeStyles({
  img: {
    height: 30,
    width: 'auto',
    filter: 'brightness(0) invert(1)', // Transform everything to pure white
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <img className={classes.img} src={sauterSymbol} alt="Sauter" />;
};
